module.exports = __webpack_public_path__ + "img/out-img3.6e6cb3aa.png";